
export const DEFAULT_PAGING_VALUE = 40;

export const DEFUALT_ADDRESS = "127.0.0.1";

export const DEFAULT_PORT = "8222";
